import { v4 } from 'uuid';
import config from '../config';
import { base64Encode } from '@firebase/util';

const deviceStorageKey = 'token-device-id';

export const fetchGuestToken = async (): Promise<string> => {
    let deviceId = window.localStorage.getItem(deviceStorageKey);
    if (!deviceId) {
        deviceId = v4();
        window.localStorage.setItem(deviceStorageKey, deviceId);
    }

    const url = `${config.keycloakAuthURL}/realms/Users/protocol/openid-connect/token?device_id=${deviceId}`;

    const credential = base64Encode(`tp-guest:${config.keycloakGuestSecret}`);

    const headers = {
        Authorization: `Basic ${credential}`,
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
    };

    let formData: URLSearchParams = new URLSearchParams();
    formData.append('grant_type', 'client_credentials');

    const tokenResponse = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: formData.toString(),
    });

    if (!tokenResponse.ok) {
        throw Response.error;
    }

    const jsonBody = await tokenResponse.json();
    return jsonBody.access_token;
};
